import { appAssetUrl } from "./staticAssets";

const STYLE_CACHE_VERSION =
  process.env.REACT_APP_STYLE_CACHE_VERSION ||
  process.env.REACT_APP_BUILD_VERSION ||
  "1";

/** Stylesheets served from CDN (formerly under src/assets/css). */
const APP_STYLESHEETS = [
  "AboutUs.css",
  "Articles.css",
  "Blogs.css",
  "Business.css",
  "connection.css",
  "Editors.css",
  "header.css",
  "HelpCenter.css",
  "History.css",
  "JobNotification.css",
  "JobSearch.css",
  "ManageResume.css",
  "Message.css",
  "navigation.css",
  "newsFeed.css",
  "notification.css",
  "people.css",
  "PersonalProfile.css",
  "Post.css",
  "PrivacyPolicy.css",
  "ResumeDesign.css",
  "setting.css",
  "SignIn.css",
  "toggle.css",
  "userAuth.css",
  "ViewResume.css",
];

const loadedStylesheets = new Set();

export const loadAppStylesheet = (fileName) => {
  const normalized = String(fileName || "").replace(/^css\//, "");
  const href = `${appAssetUrl(`css/${normalized}`)}?v=${encodeURIComponent(
    STYLE_CACHE_VERSION,
  )}`;

  if (loadedStylesheets.has(href)) return href;

  loadedStylesheets.add(href);
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  link.setAttribute("data-wlj-cdn-style", normalized);
  document.head.appendChild(link);

  return href;
};

APP_STYLESHEETS.forEach(loadAppStylesheet);
